import { constants } from '../config';

const initialState = {
  show: false,
  firstTimeOpened: true,
};

export default function setShowRedirectToRegisterReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SHOW_MODAL: {
      return {
        ...state,
        show: action.show,
        firstTimeOpened: false,
      };
    }
    default:
      return {
        ...state,
      };
  }
}
